export class Echo<T = string> {
    public key?: string;
    public title?: string;
    public entity?: T;
    public info?: any;

    constructor(public message: string) {
    }
}
